import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes, LINE_ITEM_PROVIDER_COMMISSION } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemProviderCommissionRefundMaybe = props => {
  const { lineItems, isProvider, intl, transaction } = props;

  const refund = lineItems.find(
    item => item.code === LINE_ITEM_PROVIDER_COMMISSION && item.reversal
  );

  if (!isProvider || !refund) {
    return null;
  }

  // MANUAL PAYOUT FIX: For cancelled manual payout transactions,
  // calculate actual commission refund from metadata instead of using -100% reversal
  const protectedData = transaction?.attributes?.protectedData || {};
  const manual = protectedData?.manualProviderPayoutMetadata || protectedData?.manualPayoutMetadata || null;
  const subtotal = protectedData?.subtotal || null;
  
  let refundAmount = refund.lineTotal;
  
  if (manual && manual.requiresManualPayout) {
    // SIMPLE FIX: Use the REAL commission directly from metadata
    // Refund is the negative of the commission (positive because it's given back)
    
    if (typeof manual.realProviderCommission === 'number') {
      // Use real commission from metadata
      const actualCommissionInCents = manual.realProviderCommission; // Already negative
      refundAmount = new sdkTypes.Money(-actualCommissionInCents, refund.lineTotal.currency);
      
      console.log('[PROVIDER REFUND] Using real commission from metadata:', {
        realCommission: actualCommissionInCents,
        refund: -actualCommissionInCents,
        refundAmountObject: refundAmount
      });
    } else if (subtotal && typeof manual.providerPayoutAmount === 'number') {
      // Fallback calculation
      const subtotalInCents = manual.realSubtotal ?? subtotal.amount;
      const providerPayoutInCents = manual.providerPayoutAmount;
      const actualCommissionInCents = providerPayoutInCents - subtotalInCents;
      refundAmount = new sdkTypes.Money(-actualCommissionInCents, refund.lineTotal.currency);
      
      console.log('[PROVIDER REFUND] Commission refund calculation (fallback):', {
        subtotal: subtotalInCents,
        providerPayout: providerPayoutInCents,
        commission: actualCommissionInCents,
        refund: -actualCommissionInCents
      });
    }
  } else {
    console.log('[PROVIDER REFUND] Skipping manual calculation:', {
      hasManual: !!manual,
      requiresManual: manual?.requiresManualPayout,
      hasSubtotal: !!subtotal,
      payoutAmount: manual?.providerPayoutAmount
    });
  }

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingBreakdown.refundProviderFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, refundAmount, true)}</span>
    </div>
  );
};

LineItemProviderCommissionRefundMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemProviderCommissionRefundMaybe;
